function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.9524 17.893V20.2733C10.9524 20.5221 11.2064 20.7238 11.5 20.7238C11.8024 20.7238 12.0476 20.5147 12.0476 20.2733V17.893C12.6857 17.7041 13.1429 17.1943 13.1429 16.5951C13.1429 15.835 12.4073 15.2189 11.5 15.2189C10.5927 15.2189 9.85714 15.835 9.85714 16.5951C9.85714 17.1943 10.3143 17.7041 10.9524 17.893ZM3.28571 10.6315V7.41964C3.28571 3.61896 6.96338 0.539261 11.5 0.539261C16.0274 0.539261 19.7143 3.61971 19.7143 7.41964V10.6315C21.5314 10.6359 23 11.8704 23 13.3926V22.55C23 24.0848 21.5246 25.3111 19.7047 25.3111H3.29534C1.47374 25.3111 0 24.0749 0 22.55V13.3926C0 11.8605 1.47017 10.6358 3.28571 10.6315ZM6.57143 10.6315V7.42112C6.57143 5.13513 8.77802 3.29169 11.5 3.29169C14.2164 3.29169 16.4286 5.1405 16.4286 7.42112V10.6315H6.57143Z",
  fill: "#EFEFEF"
});

var SvgLockIcon = function SvgLockIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLockIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lock-icon.766b04f9.svg";
export { ForwardRef as ReactComponent };